var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { useSettingsHandlers } from '@/presentation/providers/settings-handlers-provider';
import { getContainerHeight } from '@/presentation/common-utils/common-utils';
import { Box, Button, ColumnLayout, Container, FormField, Grid, Header, Select, SpaceBetween } from '@cloudscape-design/components-themed/components';
import { PATH_SETTINGS } from '@/presentation/common-utils/constants';
import { useNavigate } from 'react-router-dom';
import CodeEditor from "@/presentation/components/code-editor/code-editor";
import { useIsMounted } from '@/presentation/hooks';
import { makeProvidersSelectionOptions } from '../../common';
const ActionMetadataOverrides = ({ isUserAdmin }) => {
    const [loading, setLoading] = useState(true);
    const [metadataValue, setMetadataValue] = useState('');
    const [selectedProvider, setSelectedProvider] = useState(null);
    const [providersList, setProvidersList] = useState([]);
    const [editorHeight, setEditorHeight] = useState(400);
    const [currentRef, setCurrentRef] = useState(null);
    const ref = React.useRef(null);
    const { settings, providers } = useSettingsHandlers();
    const settingsHandler = settings;
    const providersHandler = providers;
    const navigate = useNavigate();
    const isMounted = useIsMounted();
    useEffect(() => {
        if (isMounted.current) {
            setCurrentRef(ref === null || ref === void 0 ? void 0 : ref.current);
        }
    }, [ref === null || ref === void 0 ? void 0 : ref.current]);
    useEffect(() => {
        // The DOM element is accessible here.
        if (currentRef) {
            getContainerHeight('settingsActionMetadataOverridesEditor', setEditorHeight, editorHeight);
        }
    }, [currentRef]);
    useEffect(() => {
        const fetchData = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            try {
                const providers = yield providersHandler.listEntity();
                if (!isMounted.current)
                    return;
                const providerOptions = makeProvidersSelectionOptions(providers).sort((a, b) => { var _a, _b; return ((_a = a.label) !== null && _a !== void 0 ? _a : '').localeCompare((_b = b.label) !== null && _b !== void 0 ? _b : ''); });
                setProvidersList(providerOptions);
                if (providerOptions.length > 0) {
                    setSelectedProvider(providerOptions.find(option => option.label === 'AWS') || providerOptions[0]);
                }
                try {
                    const actionMetadata = yield settingsHandler.listActionMetadataOverrides();
                    if (!isMounted.current)
                        return;
                    const { metadata, Provider } = ((_a = actionMetadata === null || actionMetadata === void 0 ? void 0 : actionMetadata.ActionMetadataOverrides) === null || _a === void 0 ? void 0 : _a[0]) || {};
                    setMetadataValue(metadata ? JSON.stringify(metadata, null, 2) : '');
                    if (Provider === null || Provider === void 0 ? void 0 : Provider.name) {
                        const providerOption = providerOptions.find(option => option.label === (Provider === null || Provider === void 0 ? void 0 : Provider.name)) || providerOptions[0];
                        setSelectedProvider(providerOption);
                    }
                }
                finally {
                    if (isMounted.current)
                        setLoading(false);
                }
            }
            catch (e) {
                console.error(e);
            }
        });
        fetchData();
    }, []);
    const tabbedContentPaddings = 60;
    return React.createElement(Container, { header: React.createElement(Header, { variant: "h2" }, "Action Metadata") },
        React.createElement(SpaceBetween, { direction: "vertical", size: "l" },
            React.createElement(FormField, { label: "Provider" },
                React.createElement(Select, { selectedOption: selectedProvider, disabled: true, onChange: ({ detail }) => {
                        setSelectedProvider(detail.selectedOption);
                    }, options: providersList, filteringType: "auto", selectedAriaLabel: "Selected" })),
            React.createElement(ColumnLayout, { columns: 1, variant: "text-grid" },
                React.createElement("div", { ref: ref, id: "settingsActionMetadataOverridesEditor" },
                    React.createElement(SpaceBetween, { direction: "vertical", size: "l" },
                        React.createElement(Grid, { gridDefinition: [{ colspan: 6 }, { colspan: 6 }] },
                            React.createElement(Box, { float: "left" },
                                React.createElement(SpaceBetween, { direction: "horizontal", size: "xs" },
                                    React.createElement(FormField, { label: "Action Metadata Overrides" }))),
                            React.createElement(Box, { float: "right" },
                                React.createElement(SpaceBetween, { direction: "horizontal", size: "xs" },
                                    React.createElement(Button, { onClick: () => {
                                            navigate(PATH_SETTINGS.ACTION_METADATA_OVERRIDES + '/' + (selectedProvider === null || selectedProvider === void 0 ? void 0 : selectedProvider.label) + '/edit');
                                        } }, "Edit")))),
                        React.createElement(CodeEditor, { loading: loading, code: metadataValue, height: editorHeight - tabbedContentPaddings, heightType: 'px', readOnly: true, language: 'json' }))))));
};
export default ActionMetadataOverrides;
